// extracted by mini-css-extract-plugin
export default {"top-wrapper":"AuthHeader_top-wrapper__VNf4w","logo":"AuthHeader_logo__wKr02","back-button":"AuthHeader_back-button__vD7RD"};